import script from "./UCTextarea.vue?vue&type=script&setup=true&lang=js"
export * from "./UCTextarea.vue?vue&type=script&setup=true&lang=js"

import "./UCTextarea.vue?vue&type=style&index=0&id=485c0a50&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-485c0a50"]])

export default __exports__